var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.4134 4.45312V23.5598C10.9601 23.5731 10.5067 23.6798 10.1734 23.8798L7.04007 25.6665C4.85341 26.9198 3.05341 25.8798 3.05341 23.3465V10.3731C3.05341 9.53313 3.65341 8.49312 4.40007 8.06646L10.1734 4.75979C10.5067 4.57313 10.9601 4.46646 11.4134 4.45312Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9734 8.44024V27.5469C20.5067 27.5602 20.0534 27.4802 19.6934 27.3069L12.6934 23.8002C12.3334 23.6269 11.8801 23.5469 11.4134 23.5602V4.45358C11.8801 4.44024 12.3334 4.52024 12.6934 4.69358L19.6934 8.20024C20.0534 8.37358 20.5067 8.45358 20.9734 8.44024Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M29.3333 8.65309V21.6264C29.3333 22.4664 28.7333 23.5064 27.9867 23.9331L22.2133 27.2398C21.88 27.4264 21.4267 27.5331 20.9733 27.5464V8.43976C21.4267 8.42643 21.88 8.31976 22.2133 8.11976L25.3467 6.33309C27.5333 5.07976 29.3333 6.11976 29.3333 8.65309Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a0294f1574dc1a04baf446c8e51144c7.svg";
export { ForwardRef as ReactComponent };